export default "__VITE_ASSET__Cr5ZQzgb__"